export function getPublishedBookPlaylist(item) {
    return item?.Playlist || item?.playlist || null;
}

export function getPublishedBookItemKey(item) {
    const playlist = getPublishedBookPlaylist(item);
    const playlistID = item?.playlistID ?? playlist?.ID ?? item?.ID ?? '';
    const websiteCode = item?.WebsiteCode ?? item?.websiteCode ?? '';
    const divisionCode = item?.DivisionCode ?? item?.divisionCode ?? '';

    return `${playlistID}-${websiteCode}-${divisionCode}`;
}
